import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import React from "react";
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import TimsPlace from './components/TimsPlace';


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export default function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tims-place" element={<TimsPlace />} />
      </Routes>
    </ThemeProvider>
  );
}
